export const getBackendUrl = (): string => {
	const { href } = window.location;
	if (href.includes("qa")) {
		return `${process.env.BASE_URL_QA}`;
	} else if (href.includes("localhost")) {
		return `${process.env.BASE_URL_QA}`;
	} else {
		return `${process.env.BASE_URL_PROD}`;
	}
};